import type { LoggingService } from './LoggingService';

export const loggingServiceFactory = ({
  setLevel = () => {},
  debug = () => {},
  trace = () => {},
  log = () => {},
  info = () => {},
  warn = () => {},
  error = () => {},
}: Partial<LoggingService> = {}): LoggingService => ({
  setLevel,
  debug,
  trace,
  log,
  info,
  warn,
  error,
});
